// fieldDropEligibilityUtils.js
import { SELECTED_SO_CODE_NZLO, SELECTED_SO_CODE_FINO } from "../constants/soCode";
import { getDuration } from "../components/pages/OpenStation/stationUtils";

// Define the mapping
const fieldDropMap = {
  [SELECTED_SO_CODE_NZLO]: 28,
  [SELECTED_SO_CODE_FINO]: 30,
};

// Function to get the mapped value
export const getFieldDropDays = (code) => fieldDropMap[code] ?? null;
/**
 * Determines if a child is eligible for field drop popup.
 * Uses the configured threshold from appConstants and SO-specific logic.
 * @param {Object} child - Child object
 * @param {string} soCode - SO code
 * @param {number|string} fdNumberofDays - Number of days for eligibility
 * @returns {boolean} True if eligible, false otherwise
 */
export function isFieldDropEligible(child, soCode, fdNumberofDays, navigateFromAccounts=false) {
  const today = new Date();
  const droppedChildDetails= navigateFromAccounts ? child: child?.droppedChildDetails;
  const sponsorshipEndDateStr = navigateFromAccounts? droppedChildDetails?.sponsorshipEndDate : droppedChildDetails?.childSponsorshipEndDate;
  const isEligibleFlag = child?.isCelebrationEligible;
  const isSensitive = droppedChildDetails?.isSensitive ;
  const rflId = navigateFromAccounts ? droppedChildDetails?.rflid : droppedChildDetails?.rflId;

  if (!sponsorshipEndDateStr) return false;
  if (!rflId) return false; // RFLID must not be null

  // Always use fdNumberofDays, fallback to getFieldDropDays if not provided
  const daysToAdd = Number(fdNumberofDays) || getFieldDropDays(soCode);
  const sensitiveFlag = (isSensitive === "true" || isSensitive === true);
  if (soCode === SELECTED_SO_CODE_NZLO && sensitiveFlag) {
    return navigateFromAccounts === true;
  }
  const sponsorshipEndDate = new Date(sponsorshipEndDateStr);
  if (isNaN(sponsorshipEndDate)) return false;

  const endDatePlusX = new Date(sponsorshipEndDate);
  endDatePlusX.setDate(endDatePlusX.getDate() + daysToAdd);

  const isEligible = isEligibleFlag === null || isEligibleFlag === "false" || isEligibleFlag === false;

  return today >= sponsorshipEndDate && today <= endDatePlusX && isEligible;
}

export const getFormattedEndDate = (sponsorshipEndDateStr, noOfDays, soCode) => {
  const daysToAdd = Number(noOfDays)|| getFieldDropDays(soCode);
  const sponsorshipEndDate = new Date(sponsorshipEndDateStr);
  if (isNaN(sponsorshipEndDate)) return null;
  const endDatePlusX = new Date(sponsorshipEndDate);
  endDatePlusX.setDate(endDatePlusX.getDate() + daysToAdd);
  return getDuration(endDatePlusX);
}
export const formatUIDescription = (text, childName, gender, project) => {
// Map pronouns based on gender
const pronouns = gender === "F"
  ? { hisHer: "her", heShe: "she", himselfHerself: "herself" }
  : { hisHer: "his", heShe: "he", himselfHerself: "himself" };

// Replace placeholders with actual values
return text
  .replace(/{Child'sFirstName}/g, childName)
  .replace(/{his\/her}/g, pronouns.hisHer)
  .replace(/{he\/she}/g, pronouns.heShe)
  .replace(/{himself\/herself}/g, pronouns.himselfHerself)
  .replace(/{project}/g, project);
};